// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd43177a","277":"f0cfe684","455":"3db75551"}[chunkId] + ".chunk.js";
};